import { REGISTRATION_BENEFIT, REGISTRATION_BENEFIT_SUCCESS, REGISTRATION_BENEFIT_ERROR, REGISTRATION_BENEFIT_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RegistrationBenefit = (state = initialState, action) => {
  switch (action.type) {
    case REGISTRATION_BENEFIT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case REGISTRATION_BENEFIT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case REGISTRATION_BENEFIT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case REGISTRATION_BENEFIT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RegistrationBenefit;
